/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F6_AInputs */

const en_mk_sec_pg_f6_a = /** @type {(inputs: Mk_Sec_Pg_F6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Every run keeps its step transcript along with its cost, and the Usage page summarises it per agent.`)
};

const id_mk_sec_pg_f6_a = /** @type {(inputs: Mk_Sec_Pg_F6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Setiap run menyimpan transkrip langkahnya beserta biaya, dan halaman Pemakaian merangkumnya per agen.`)
};

/**
* | output |
* | --- |
* | "Yes. Every run keeps its step transcript along with its cost, and the Usage page summarises it per agent." |
*
* @param {Mk_Sec_Pg_F6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f6_a = /** @type {((inputs?: Mk_Sec_Pg_F6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f6_a(inputs)
	return en_mk_sec_pg_f6_a(inputs)
});